import {Component, OnInit} from '@angular/core';
import {SharedService} from "../../core/services/store/shared-store/shared-storage.service";
import {CMSService} from "../../shared/components/cms/service/cms.service";
import {AddCollectionsComponent} from "./components/add-collections/add-collections.component";
import {MatDialog} from "@angular/material/dialog";
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgClass, AsyncPipe } from '@angular/common';
import { MatCheckbox } from '@angular/material/checkbox';
import { CollectionsTableComponent } from './components/collections-table/collections-table.component';

@Component({
    selector: 'app-analytics-settings',
    templateUrl: './analytics-settings.component.html',
    styleUrls: ['./analytics-settings.component.scss'],
    imports: [ReactiveFormsModule, FormsModule, NgClass, MatCheckbox, CollectionsTableComponent, AsyncPipe]
})
export class AnalyticsSettingsComponent implements OnInit {

  constructor(
      public sharedService: SharedService,
      public cmsService: CMSService,
      private dialog: MatDialog) {

  }

  cmsText;
  trial;
  searchCollectionsValue = '';
  collectionStatus = 'loading';
  canSelectCollections = false;
  canEditCollections = true;
  showFilter = false;
  isApplyFilter = false;
  selectedFilters = [];
  collectionFilters  = [
    {
      name: 'multiDataPoints',
      label: 'Multi Data Points',
      styleClass: 'multi-data-points',
      selected: false
    },
    {
      name: 'singleDataPoints',
      label: 'Single Data Point',
      styleClass: 'single-data-points',
      selected: false
    },
    {
      name: 'twoDataPoints',
      label: 'Start & End Data Points',
      styleClass: 'two-data-points',
      selected: false
    },
  ];

  ngOnInit(): void {
    this.trial = this.cmsService.cmsCall('y1T82WizzjMIX8QpxyEZC', 'entry');
  }
  openPopup() {
    const dialogRef = this.dialog.open(AddCollectionsComponent, {
    });
  }

  onFilterButtonClick() {
    this.showFilter = true;
    this.isApplyFilter = false;
  }

  onFilterApply() {
    this.showFilter = false;
    const selectedFilters = this.collectionFilters.filter(filter => filter.selected);
    const filters = [];
    selectedFilters.forEach(filter => filters.push(filter.label));
    this.selectedFilters = filters;
  }

  onFilterCancel() {
    this.showFilter = false;
    this.collectionFilters.forEach(filter => {
      filter.selected = false;
    });
    this.setIsApplyFilter();
    this.selectedFilters = [];
  }

  onFilterChange(event: any, name: string) {
    this.collectionFilters.forEach(filter => {
      if(filter.name === name) {
        filter.selected = event.checked;
      }
    })
    this.setIsApplyFilter();
  }

  setIsApplyFilter() {
    const selectedFilters = this.collectionFilters.filter(filter => filter.selected);
    this.isApplyFilter = selectedFilters.length > 0 ? true : false;
  }

  getCMSText(entryID: string, cmsType: string): string {
    this.cmsText = this.cmsService.cmsCall(entryID, cmsType);
    return this.cmsText;
  }

}
